import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { settingsApi } from '../services/apiService';
import LoadingScreen from './LoadingScreen';

interface MaintenanceGuardProps {
    children?: React.ReactNode;
}

export default function MaintenanceGuard({ children }: MaintenanceGuardProps) {
    const [loading, setLoading] = useState(true);
    const [maintenanceMode, setMaintenanceMode] = useState(false);
    const [maintenanceText, setMaintenanceText] = useState('');

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const settings = await settingsApi.get();
                setMaintenanceMode(settings.maintenanceMode || false);
                setMaintenanceText(settings.maintenanceText || '');
            } catch (err) {
                console.error('Failed to check maintenance mode', err);
            } finally {
                setLoading(false);
            }
        };
        fetchSettings();
    }, []);

    if (loading) {
        return <LoadingScreen />;
    }

    if (maintenanceMode) {
        return (
            <div className="min-h-screen bg-[#F5F1EB] flex flex-col items-center justify-center p-4">
                <div className="max-w-md text-center space-y-6">
                    <div className="mx-auto w-24 h-24 bg-[#5c2b2b]/10 rounded-full flex items-center justify-center mb-8 shadow-sm">
                        <svg className="w-12 h-12 text-[#5c2b2b]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                        </svg>
                    </div>
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-serif text-slate-800 tracking-tight">Prace Techniczne</h1>
                    <p className="text-lg text-slate-600 leading-relaxed font-medium whitespace-pre-line">
                        {maintenanceText.trim() || "Strona w przebudowie. Wprowadzamy poprawki, aby Twój proces zakupowy był jeszcze lepszy. Wracamy wkrótce!"}
                    </p>
                    <div className="pt-6">
                        <span className="text-sm font-bold uppercase tracking-[0.2em] text-[#5c2b2b]">Włoska Piwnica</span>
                    </div>
                </div>
            </div>
        );
    }

    return children ? <>{children}</> : <Outlet />;
}
